import React from 'react';

export default ({ alignment, children }) => (
  <div style={{ textAlign: alignment }}>{children}</div>
);



// WEBPACK FOOTER //
// ./src/pages/lettersetup/components/Alignment.js